import { useState } from "react";
import { useIsMobile } from "@/hooks/useIsMobile";
import type { StockArticle } from "@/lib/stock.api";
import type { StockMovementWithArticle } from "@/hooks/queries/useStockMovements";

export function useStockArticlesPageState() {
  const [includeInactive, setIncludeInactive] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState<StockArticle | null>(null);
  const [selectedMovement, setSelectedMovement] = useState<StockMovementWithArticle | null>(null);
  const isMobile = useIsMobile();

  return {
    includeInactive,
    setIncludeInactive,
    selectedArticle,
    setSelectedArticle,
    selectedMovement,
    setSelectedMovement,
    isMobile,
  };
}
